import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AssetCardComponent } from '@features/shopping/asset/card/asset-card.component';
import { DeviceAsset, LineAsset, UserAsset } from '@models/dashboard.model';
import {
  MULTI_SIM_TYPES,
  hasDeviceCatalogId,
  hasDeviceId,
  hasLineId
} from '@models/functions.model';
import { NgbOffcanvasModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { DashboardAssetComponent } from '@shared-components/asset-types/dashboard-asset/dashboard-asset.component';
import { EligibilityBadgeComponent } from '@shared-components/badge/eligibility-badge/eligibility-badge.component';
import { StatusBadgeComponent } from '@shared-components/badge/status-badge/status-badge.component';

@Component({
  selector: 'ts-multisim-offcanvas',
  imports: [
    CommonModule,
    NgbOffcanvasModule,
    AssetCardComponent,
    DashboardAssetComponent,
    EligibilityBadgeComponent,
    StatusBadgeComponent,
    TranslationPipe
  ],
  templateUrl: './multisim-offcanvas.component.html'
})
export class MultisimOffcanvasComponent {
  @Input() offcanvas_asset: UserAsset | undefined;
  @Input() offcanvas: any;
  multi_sim_types: string[] = MULTI_SIM_TYPES;

  offCanvasAssetTitle(): string {
    let title: string = '';

    switch (this.offcanvas_asset?.multi_sim_type) {
      case MULTI_SIM_TYPES[0]:
        if (this.offcanvas_asset.device?.manufacturer)
          title += this.offcanvas_asset.device?.manufacturer + ' ';
        if (this.offcanvas_asset.device?.model) title += this.offcanvas_asset.device?.model + ' ';
        if (this.offcanvas_asset.device?.size) title += this.offcanvas_asset.device?.size + ' ';
        if (this.offcanvas_asset.device?.color) title += ' - ' + this.offcanvas_asset.device?.color;
        break;
      case MULTI_SIM_TYPES[1]:
      case MULTI_SIM_TYPES[6]:
        title += this.offcanvas_asset.line.international_number;
        break;
      case MULTI_SIM_TYPES[2]:
      case MULTI_SIM_TYPES[3]:
        if (this.offcanvas_asset && hasDeviceId(this.offcanvas_asset.device)) {
          if (this.offcanvas_asset.device?.manufacturer)
            title += this.offcanvas_asset.device?.manufacturer + ' ';
          if (this.offcanvas_asset.device?.model) title += this.offcanvas_asset.device?.model + ' ';
          if (this.offcanvas_asset.device?.size) title += this.offcanvas_asset.device?.size + ' ';
          if (this.offcanvas_asset.device?.color)
            title += ' - ' + this.offcanvas_asset.device?.color;
        }
        break;
      case MULTI_SIM_TYPES[4]:
      case MULTI_SIM_TYPES[5]:
        if (this.offcanvas_asset && hasLineId(this.offcanvas_asset.line))
          title += this.offcanvas_asset.line.international_number;
        break;
    }

    return title;
  }

  hasLineId(line: LineAsset): boolean {
    return hasLineId(line);
  }

  hasDeviceId(device: DeviceAsset): boolean {
    return hasDeviceId(device);
  }

  hasRefDevice(device: DeviceAsset): boolean {
    return hasDeviceCatalogId(device);
  }

  isDeviceAsset(multi_sim_type: string): boolean {
    return [this.multi_sim_types[0], this.multi_sim_types[2], this.multi_sim_types[3]].includes(
      multi_sim_type
    );
  }

  isLineAsset(multi_sim_type: string): boolean {
    return [
      this.multi_sim_types[1],
      this.multi_sim_types[4],
      this.multi_sim_types[5],
      this.multi_sim_types[6]
    ].includes(multi_sim_type);
  }
}
